var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverLicenseNotupdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ic_driver_license_notupdated",
    "data-name": "Ic_driver license_notupdated",
    transform: "translate(-1441 -395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-profile-1146332",
    transform: "translate(1441 395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M202.844,304.637H189.06v-1.844a6,6,0,0,1,6-6h1.794a6,6,0,0,1,6,6Z",
    transform: "translate(-189.06 -287.518)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M254.32,88.639a4.285,4.285,0,1,1,3.024-1.254,4.28,4.28,0,0,1-3.024,1.254Z",
    transform: "translate(-247.428 -80.078)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(-2040 122)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3489 283)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 3,
    y2: 3,
    transform: "translate(3492.5 286.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicenseNotupdated);
export default __webpack_public_path__ + "static/media/driver_license_notupdated.83a90b3dbf91d0819aac107e45857d9b.svg";
export { ForwardRef as ReactComponent };